module.exports = __webpack_public_path__ + "static/media/measure2.bf4f570c.png";